import { writeLegalAcceptanceToLocalStorage } from "./legalAcceptanceLocal";
import type { LegalAcceptanceStatusResponse } from "./legalAcceptanceTypes";

/**
 * Persists acceptance of the currently published documents (DB if signed in, always localStorage).
 */
export async function recordLegalAcceptanceOnClient(): Promise<boolean> {
  const statusResponse = await fetch("/api/legal/status");
  if (!statusResponse.ok) {
    return false;
  }
  const status = (await statusResponse.json()) as LegalAcceptanceStatusResponse;
  const acceptResponse = await fetch("/api/legal/accept", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      termsVersion: status.terms.version,
      privacyVersion: status.privacy.version,
    }),
  });
  if (!acceptResponse.ok) {
    return false;
  }
  writeLegalAcceptanceToLocalStorage({
    termsVersion: status.terms.version,
    privacyVersion: status.privacy.version,
  });
  return true;
}
